/**
 * 加载时机，它们的 key 表示时机的种类，值表示优先级
 * ON_DEMAND：调用时加载
 * IDLE：闲时加载
 * EAGER：立即加载
 */
export var LoadType = /*#__PURE__*/function (LoadType) {
  LoadType[LoadType["IDLE"] = 1] = "IDLE";
  LoadType[LoadType["ON_DEMAND"] = 3] = "ON_DEMAND";
  LoadType[LoadType["EAGER"] = 7] = "EAGER";
  return LoadType;
}({});
//# sourceMappingURL=load-type.js.map